import { InfoSmIcon, WarningSmIcon } from '@crono-one/design-system';
import { cn } from 'utils/style-utils';

interface CrmConnectErrorBannerProps {
  message: string;
  /** `warning` for a working connection that still needs attention. */
  tone?: 'error' | 'warning';
}

/** A connection problem, pinned to the top of the CRM card below it. */
const CrmConnectErrorBanner = ({
  message,
  tone = 'error',
}: CrmConnectErrorBannerProps) => {
  const Icon = tone === 'error' ? WarningSmIcon : InfoSmIcon;
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn(
        'flex items-center gap-1.5 rounded-t-lg border border-b-0 border-neutral-300 px-4 py-0.75 text-xs leading-4 font-medium',
        tone === 'error'
          ? 'bg-red-100 text-red-600'
          : 'bg-orange-200 text-orange-700',
      )}
    >
      <Icon className="size-4 shrink-0" />
      <span>{message}</span>
    </div>
  );
};

export default CrmConnectErrorBanner;
